import React from 'react';
import { Switch, Route } from 'react-router';
import { AppRoutes, getAppRouteCacheName } from '../../../routes';
import { DevicesOrganization } from './DevicesOrganization';
import { DevicesOrganizationDeviceDetails } from './DevicesOrganizationDeviceDetails';
import { DeviceDataProvider } from '../../../data/DataProviders/DeviceDataProvider';
import { DataProviderCache } from '../../../data/DataProviders/DataProviderCache';
import { useCurrentAppRoute } from '../../../hooks/app-route-hooks';

export const DevicesOrganizationList: React.FC = () => {
    const currentAppRoute = useCurrentAppRoute();
    return (
        <>
            <Switch>
                <DataProviderCache for={getAppRouteCacheName(AppRoutes.DevicesOrganization)}>
                    <Route exact path={AppRoutes.DevicesOrganization} component={DevicesOrganization} />
                    {'deviceId' in currentAppRoute && (
                        <Route exact path={AppRoutes.DevicesOrganizationDeviceDetails}>
                            <DataProviderCache for={getAppRouteCacheName(AppRoutes.DevicesOrganizationDeviceDetails)}>
                                <DeviceDataProvider deviceId={currentAppRoute.deviceId}>
                                    <DevicesOrganizationDeviceDetails />
                                </DeviceDataProvider>
                            </DataProviderCache>
                        </Route>
                    )}
                </DataProviderCache>
            </Switch>
        </>
    );
};
